<div class="modal" data-iframe-size>
  <img class="icon" [src]="warningUrl">
  <h4 class="title" translate>
    i18n.dialog.deletePlaceholder.title
  </h4>

  <mat-dialog-content>
    <div class="content" translate>i18n.dialog.deletePlaceholder.message</div>
  </mat-dialog-content>

  <dialog-buttons [buttons]="buttons"></dialog-buttons>
</div>
